import { takeLatest } from 'redux-saga/effects';
import { PORTAL_LANGUAGE } from '../actions/actionTypes';
import { getPortalLanguage } from '../actions/action';

function* languageSaga() {
  yield takeLatest(PORTAL_LANGUAGE, getPortalLanguage);
}

export default languageSaga;
